export default __webpack_public_path__ + "static/media/plain-sticker-F.ecabd985.png";